import { MenuProps, FeaturedImageProps } from "@made-people/blueprint-menu";

export const Deck2MenuDefaults: MenuProps = {
  template: "deck2",
  links: {
    variants: {
      style: "no-underline",
    },
  },
};

export const FeaturedImage: FeaturedImageProps = {};
